export var categoriesPic = [
	[
		"fgoServantPic", 
		"Servant Picture", 
		"https://doigrgvizfuvs.cloudfront.net/assets/Attila_pic1-body.png",
		"Attila body pic"
	],
	[
		"fgoBondCe", 
		"Bond CE", 
		"https://doigrgvizfuvs.cloudfront.net/assets/DaVinci_Craft_Essence.png",
		"Da Vinci Bond CE"
	],
	[
		"fgoSprite", 
		"Servant Sprite", 
		"https://doigrgvizfuvs.cloudfront.net/assets/Jack_the_Ripper_sprite.png",
		"Jack the ripper sprite"
	],
	[
		"fgoValentines", 
		"Valentine", 
		"https://doigrgvizfuvs.cloudfront.net/assets/Orion_Chocolate.jpg",
		"Orion Valentines Chocolate"
	],
	[
		"fgoShoes", 
		"Shoe", 
		"https://doigrgvizfuvs.cloudfront.net/assets/Mashu_Kyrielight_Shoes.png",
		"Mash Kyrielight Shoes"
	],
	[
		"fgoItem", 
		"Item", 
		"https://doigrgvizfuvs.cloudfront.net/assets/Mysterious_Heroine_X_swords.png",
		"Mysterious Heroine X MHX swords"
	],
	[
		"fgoNpAudio", 
		"Noble Phantasm", 
		"https://doigrgvizfuvs.cloudfront.net/assets/audio.png",
		"Listen to this"
	]
];

export var categoriesText = [
	[
		"fgoBio", 
		"Bio and Quote", 
		["Ah... Don't stare at me so hard. It makes me want to remove your bones, melt you into a nice red wine, and drink you all up..."]
	],
	[
		"fgoNP", 
		"Noble Phantasm", 
		["Rule Breaker", "Golden Spark", "Smile of Stheno"]
	]
];



// WEBPACK FOOTER //
// ./src/components/constants/categories.js